module.exports = __webpack_public_path__ + "img/ny7.png";